module.exports = __webpack_public_path__ + "img/minji.6f97285a.png";